customElements.define('product-card', class extends HTMLElement {
  constructor() {
    super();
    this.image = this.querySelector('.product-card__img');
    this.imageOnHover = this.querySelector('[data-on-hover-src]');
    this.color = this.querySelector('.product-card__color');
    this.selectedSwatch = this.querySelector('.color-swatch--selected');
    this.variantId = this.querySelector('[variant-ids]');
    this.urls = this.querySelectorAll('.product-card__url');
    this.quickBuyBtn = this.querySelector('.button-quick-buy');
    this.ctaText = this.querySelector('.button-quick-buy span');
    this.badge = this.querySelector('.product-badge');
    this.priceBlock = this.querySelector('.price');
    this.priceItemSale = this.querySelector('.price-item--sale');
    this.addEventListeners();
  }

  addEventListeners() {
    this.querySelectorAll('.color-swatch').forEach(color => {
      color.addEventListener('click', () => this.onColorClick(color));
    });

    this.addEventListener('mouseover', () => this.onHover());
    this.addEventListener('mouseout', () => this.onHoverOut());

    this.addEventListener('touchstart', () => this.onHover());
    this.addEventListener('touchend', () => this.onHoverOut());
  }

  onHover() {
    if (this.image) {
      const hoverSrc = this.image.getAttribute('data-on-hover-src');
      if (hoverSrc) {
        this.image.setAttribute('data-original-src', this.image.src);
        this.image.src = hoverSrc;
      }
    }
    if (this.badge) {
      this.badge.style.display = 'none';
    }
  }

  onHoverOut() {
    if (this.image) {
      const originalSrc = this.image.getAttribute('data-original-src');
      if (originalSrc) {
        this.image.src = originalSrc;
        this.image.removeAttribute('data-original-src');
      }
    }
    if (this.badge) {
      this.badge.style.display = '';
    }
  }

  onColorClick(color) {
    const {
      productImage: newProductImage,
      productId: newVariantId,
      productColor: newProductColor,
      productAvailable: isProductAvailable,
      productIsPreOrder: isProductPreOrder,
      productIsAppExclusive: isProductAppExclusive,
      productIsBhgNoDiscount: isBhgNoDiscount,
      productBhgDiscountedPrice: newProductBhgDiscountedPrice,
      productIsBackInStock: isProductBackInStock,
      productUrl: newProductUrl,
      productImageOnHover: newProductImageOnHover,
      productBadgeImg: newProductBadgeImg,
      productBadgeBcgColor: newProductBcgColor,
      productBadgeFontColor: newProductBadgeFontColor,
      productBadgeText: newProductBadgeText,
      productBadge: newProductBadge
    } = color.dataset;
  
    // Find the currently selected swatch at the time of click
    const selectedSwatch = this.querySelector('.color-swatch--selected');
  
    // Update swatch selection
    selectedSwatch?.classList.remove('color-swatch--selected');
    color.classList.add('color-swatch--selected');
  
    // Update product image and color
    if (this.image) {
      this.image.src = newProductImage;
      this.image.setAttribute('data-original-src', newProductImage); // Update the original image
    }
    if (this.color) this.color.textContent = newProductColor;
  
    // Update product badge
    if (this.badge) {
      let badgeHtml = '';
      if (newProductBadgeImg) {
        badgeHtml = `<img src="${newProductBadgeImg}" class="product-badge__img w100" alt="Product Badge" />`;
      } else if (newProductBadgeText) {
        const bcgColor = newProductBcgColor || '#111';
        const fontColor = newProductBadgeFontColor || '#fff';
        badgeHtml = `<div class="flex-center-center center px-05" style="background-color: ${bcgColor};"><span class="font-11 bold uppercase" style="color: ${fontColor};">${newProductBadgeText}</span></div>`;
      } else if (newProductBadge) {
        badgeHtml = `<div class="product-badge__tag font-11 bold uppercase">${newProductBadge}</div>`;
      }
      this.badge.innerHTML = badgeHtml;
    }
  
    // Update hover image
    if (newProductImageOnHover) {
      this.image.setAttribute('data-on-hover-src', newProductImageOnHover);
    } else {
      this.image.removeAttribute('data-on-hover-src');
    }
  
    // Update URLs and variant ID
    this.urls.forEach(url => url.href = newProductUrl);
    if (isProductAppExclusive) {
      if (this.variantId) this.variantId.setAttribute('variant-ids', '');
    } else {
      if (this.variantId) this.variantId.setAttribute('variant-ids', newVariantId);
    }
  
    // Update availability
    if (this.quickBuyBtn) {
      let ctaText = 'Add to cart';
      this.quickBuyBtn.classList.remove('button-quick-buy__pre-order', 'BIS_trigger', 'unavailable', 'button-quick-buy__app-exclusive');
      this.quickBuyBtn.removeAttribute('data-product-data');
    
      if (isProductPreOrder) {
        ctaText = isProductPreOrder;
        this.quickBuyBtn.classList.add('button-quick-buy__pre-order');
      } else if (isProductBackInStock) {
        ctaText = 'Join the Waitlist';
        this.quickBuyBtn.classList.add('BIS_trigger');
        this.quickBuyBtn.setAttribute('data-product-data', isProductBackInStock);
      } else if (isProductAppExclusive) {
        ctaText = isProductAppExclusive;
        this.quickBuyBtn.classList.add('button-quick-buy__app-exclusive');
      }
    
      this.ctaText.innerHTML = ctaText;
      this.quickBuyBtn.classList.remove('product-added');
    }

    // Update price if bhg-no-discount tag
    if (isBhgNoDiscount) {
      this.priceBlock.classList.add('price--bhg_no_discount');
    } else {
      this.priceBlock.classList.remove('price--bhg_no_discount');
    }

    if (newProductBhgDiscountedPrice) {
      this.priceBlock.classList.remove('price--bhg_no_discount');
      this.priceItemSale.innerHTML = newProductBhgDiscountedPrice;
    } else {
      this.priceBlock.classList.add('price--bhg_no_discount');
    }

  }
});
